import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BorrowerValueState } from 'app/store/borrower-value/borrower-value.state';
import { filter, Observable, Subject, take, takeUntil } from 'rxjs';
import { Borrower } from 'lendio-borrower/models/borrower/borrower.model';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';
import { GetBorrowerStatuses } from 'ng2-app/store/borrowerStatuses/borrower-statuses.action';
import { BorrowerStatusOption } from 'ng2-app/store/borrowerStatuses/borrower-statuses.service';
import { BorrowerStatusesState } from 'ng2-app/store/borrowerStatuses/borrower-statuses.state';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventBusService } from 'ng2-app/modules/shared/services/event-bus.service';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { ChangeBorrowerStatusDialogComponent } from 'ng2-app/borrower-header/borrower-status-display/change-borrower-status/change-borrower-status-dialog.component';
import { isDefined } from 'ng2-app/modules/shared/functions/filters';

@Component({
  selector: 'app-borrower-status-display-smart',
  templateUrl: './borrower-status-display-smart.component.html',
  styleUrls: ['./borrower-status-display-smart.component.scss'],
  standalone: false
})
export class BorrowerStatusDisplaySmartComponent implements OnInit, OnDestroy {
  @Select( BorrowerValueState.complianceReview ) complianceReview$: Observable<boolean>;
  @Select( BorrowerState.borrower ) borrower$: Observable<Borrower>;
  @Select( BorrowerStatusesState.statusOptions ) statusOptions$: Observable<BorrowerStatusOption[]>;
  @Select( LenderUserState.hasPermission('canUseNewBorrowerStatusModal') ) canUseNewBorrowerStatusModal$: Observable<boolean>;

  @Input() mode: string = 'editable';

  activeDeals: number;
  destroyed$ = new Subject<boolean>();
  borrowerStatus$: Observable<BorrowerStatusOption>;
  stageColors = {
    active: '#2F85C3',
    funded: '#83CB97',
    inactive: '#909DA5',
  };

  constructor(
    private dialog: MatDialog,
    private eventBusService: EventBusService,
    private store: Store,
    private _snackBar: MatSnackBar
  ) { }

  /**
   * Ng lifecycle
   * @return void
   */
  ngOnInit(): void {
    this.store.dispatch( new GetBorrowerStatuses() );
    this.borrower$.pipe(
      filter(isDefined),
      takeUntil(this.destroyed$)
    ).subscribe( borrower => {
      this.borrowerStatus$ = this.store.select( BorrowerStatusesState.optionByStatusAlias(borrower.status) );
    });
  }

  /**
   * Ng lifecycle
   * @return void
   */
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  changeBorrowerStatus(): void {
    this.borrowerStatus$.pipe(
      take(1)
    ).subscribe( status => {
      this.dialog.open( ChangeBorrowerStatusDialogComponent, {
        height: 'auto',
        width: 'auto',
        data: {
          status
        }
      });
    });

    this.eventBusService.subscribe( this.eventBusService.types.BorrowerStatusChangedEvent )
      .pipe(takeUntil(this.destroyed$))
      .subscribe( () => {
        this._snackBar.open('Borrower Status Changed Successfully', '', {
          panelClass: 'lendio-alert--success',
        });
      });
  }

}
